export { AdSlot } from './AdSlot';
export type { AdSlotProps } from './AdSlot';
